import styled from 'styled-components';
import {
  StyledAccordion,
  StyledAccordionTitle,
  StyledAccordionContent,
} from '../../../main/theme';
import NavItem from '../../Navigation/NavItem';

export const NavigationAccordion = styled(StyledAccordion)<{
  $lightTheme?: boolean;
}>`
  background: ${({ theme, $lightTheme }) =>
    $lightTheme
      ? theme.colors.system.offWhite
      : theme.colors.system.darkBlueShadow};
  border: unset;
  border-radius: unset;
  min-width: 100%;
`;

export const NavigationAccordionTitle = styled(StyledAccordionTitle)<{
  $lightTheme?: boolean;
  $isDisabled: boolean;
}>`
  height: 46px;
  border-bottom: 1px solid
    ${({ theme, $lightTheme }) =>
      $lightTheme
        ? theme.colors.system.grey
        : theme.colors.system.darkOffBlack};

  opacity: ${({ $isDisabled }) => ($isDisabled ? '0.5' : '1')};
  cursor: ${({ $isDisabled }) =>
    $isDisabled ? 'inherit' : 'pointer'} !important;
`;

export const NavigationAccordionContent = styled(StyledAccordionContent)`
  padding: 0 !important;
  border: unset;
  background: inherit;

  > div {
    > button {
      width: 100%;

      svg {
        margin-left: ${({ theme }) => theme.margin.standard};
        margin-right: 0;
      }
    }
  }
`;

export const NavigationNavItem = styled(NavItem)`
  > div {
    width: 100%;
    display: flex;
    align-items: center;

    > svg {
      margin-left: ${({ theme }) => theme.margin.standard};
      margin-right: 0;
    }
  }
`;
